"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGCreditsScene = void 0;
const CTGMenuScene_1 = require("../CTGMenuScene");
class CTGCreditsScene extends CTGMenuScene_1.CTGMenuScene {
    constructor() {
        super("CTGCreditsScene");
    }
    onCreate() {
        super.onCreate();
        this.setTitle("Credits");
        this.addText("Game by:");
        this.addText("Kevin Hutchins");
    }
}
exports.CTGCreditsScene = CTGCreditsScene;
